import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Flex, freddyTheme, Link, Typography } from '@coolblue-development/freddy';
import { ArrowRight } from '@coolblue-development/icons';
import { hamburgerLinkStyles } from './HamburgerMenu.styles.js';
export default function HamburgerMenuChild({ item, onNavigateToChild, onNavigate, }) {
    if (item.noFollow) {
        return _jsx(_Fragment, {});
    }
    return (_jsx(Link, { href: item.url, variant: "subtle", onClick: event => {
            if (item.hasChildren) {
                event.preventDefault();
                onNavigateToChild === null || onNavigateToChild === void 0 ? void 0 : onNavigateToChild();
            }
            onNavigate();
        }, sx: hamburgerLinkStyles, children: _jsxs(Flex, { alignItems: "center", justifyContent: "space-between", py: 300, pl: 400, gap: 200, sx: theme => ({
                borderLeft: item.isCurrent
                    ? `${theme.borderWidth[50]} solid ${theme.color.border.secondary}`
                    : `${theme.borderWidth[50]} solid ${theme.color.background.tertiary}`,
            }), children: [_jsx(Typography, { fontWeight: item.isCurrent ? 700 : 400, component: "span", children: item.title }), item.hasChildren && _jsx(ArrowRight, { size: 12, fill: freddyTheme.color.icon.subtle })] }) }));
}
//# sourceMappingURL=HamburgerMenuChild.js.map